import { render, staticRenderFns } from "./configuration-automation-personnel-entities-association-grid.vue?vue&type=template&id=e23d28b4&scoped=true&"
import script from "./configuration-automation-personnel-entities-association-grid.ts?vue&type=script&lang=ts&"
export * from "./configuration-automation-personnel-entities-association-grid.ts?vue&type=script&lang=ts&"
import style0 from "./configuration-automation-personnel-entities-association-grid.scss?vue&type=style&index=0&id=e23d28b4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e23d28b4",
  null
  
)

export default component.exports